import messages from '../../locale/messages';
import { containsMalicious, inputTextLimit, strongPassword } from '../../helpers/textRestriction';
const validate = values => {
  const errors = {}

  // First Name
  if (!values.firstName || values.firstName.trim() === "") {
    errors.firstName = messages.required;
  } else if (values.firstName.length > inputTextLimit) {
    errors.firstName = messages.inputFieldRestriction;
  } else if (containsMalicious(values.firstName)) {
    errors.firstName = messages.invalidInput;;
  }

  // Last Name
  if (!values.lastName || values.lastName.trim() === "") {
    errors.lastName = messages.required;
  } else if (values.lastName.length > inputTextLimit) {
    errors.lastName = messages.inputFieldRestriction;
  } else if (containsMalicious(values.lastName)) {
    errors.lastName = messages.invalidInput;;
  }

  // Email
  if (!values.email) {
    errors.email = messages.required;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values.email)) {
    errors.email = messages.emailInvalid;
  } 

  // Password
  if (!values.password) {
    errors.password = messages.required;
  } else if (values.password.length < 8) {
    errors.password = messages.passwordInvalid;
  } else if (values.password.length > inputTextLimit) {
    errors.password = messages.inputFieldRestriction;
  } else if (!strongPassword(values.password)) {
    errors.password = messages.invalidPassword;
  }else if (containsMalicious(values.password)) {
    errors.password = messages.invalidInput;;
  }

  return errors;
}

export default validate;
